import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import DealerSearch from './search/DealerSearch';
import DealersTable from './DealersTable';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import DealersStatusFilter from './DealersStatusFilter';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { searchDealer } from './DealersActions';

function DealersPage() {
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const previousSearchState = useSelector((state) => state.dealers.get('searchState'));
  const items = useSelector((state) => state.dealers.get('items'));
  const totalItems = useSelector((state) => state.dealers.get('totalItems'));

  const initialSearchParams = {
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  };
  const [searchParams, setSearchParams] = useState(
    previousSearchState?.searchParams || initialSearchParams,
  );

  useEffect(() => {
    dispatch(
      searchDealer({
        ...searchParams,
        city: searchParams?.city === 'object' ? searchParams?.city?.value : searchParams?.city,
        tradeName:
          typeof searchParams?.tradeName === 'object'
            ? searchParams?.tradeName?.label
            : searchParams?.tradeName,
      }),
    );
  }, [dispatch, searchParams]);

  const handleChangeStatus = (status) => {
    setSearchParams((prevState) => ({ ...prevState, status, offset: 0 }));
  };

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams((prevState) => ({
      ...prevState,
      ...values,
      tradeName: values?.tradeName?.label,
      endingFreeTrialInTwoWeeks:
        values?.endingFreeTrialInTwoWeeks?.length &&
        values.endingFreeTrialInTwoWeeks[0] === true
          ? true
          : null,
      offset: 0,
    }));
    setSubmitting(false);
  };

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'span', text: 'Dealers' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Dealers" />
      <DealerSearch onSearch={handleSearch} />
      <DealersStatusFilter
        onChangeStatus={handleChangeStatus}
        previousSelectedStatus={previousSearchState?.searchParams?.status}
      />
      <DealersTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
        searchParams={searchParams}
      />
    </Container>
  );
}

export default DealersPage;
